export const TESTCASE_SERVICES = [
    { text: "None", value: null },
    { text: "Glock", value: "glock" }
];

export const TESTCASE_PROVIDERS = [
    { text: "Gmail (59)", value: 59 },
    { text: "GSuite (42)", value: 42 },
    { text: "Outlook (3)", value: 3 },
    { text: "Office365 (17)", value: 17 }
];
